// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__oQ78x","flareAnimation":"UpButton_flareAnimation__vZjbl","shine":"UpButton_shine__nyJ8X"};